export const formatGtmEventName = (name) => {
  return name.replaceAll(' - ', ' ').replaceAll(' ', '_').toLowerCase()
}
